import script from "./AlertNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertNotification.vue?vue&type=script&setup=true&lang=ts"

import "./AlertNotification.vue?vue&type=style&index=0&id=bbbe1492&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbbe1492"]])

export default __exports__